(() => {
    "use strict";

    const CONFIG = {
        ROOT: ".dtc-delivery",
        ATTR_DATE: "Delivery-Date",
        ATTR_TIME: "Delivery-Time",
        DEBOUNCE_MS: 300,
        CHECKOUT_SELECTORS: [
            'button[name="checkout"]',
            'input[name="checkout"]',
            '#checkout',
            '#cart-checkout',
            '.cart__checkout-button',
            'a[href="/checkout"]'
        ]
    };

    // --- Yardımcı Fonksiyonlar ---
    const pad2 = (n) => String(n).padStart(2, "0");
    const isoDate = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
    const prettyDate = (d) => `${pad2(d.getDate())}.${pad2(d.getMonth() + 1)}`;

    const trDow = (d) => {
        const map = ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"];
        return map[d.getDay()];
    };

    const addDays = (d, n) => {
        const x = new Date(d);
        x.setDate(x.getDate() + n);
        return x;
    };

    const qs = (el, s) => el.querySelector(s);
    const qsa = (el, s) => Array.from(el.querySelectorAll(s));

    // --- Sepet Güncelleme (Fetch) ---
    const saveAttributes = async (date, time) => {
        try {
            await fetch("/cart/update.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ attributes: { [CONFIG.ATTR_DATE]: date, [CONFIG.ATTR_TIME]: time } }),
            });
            // Not: Başarılı olunca reload yapmıyoruz, tema yaparsa yapsın.
        } catch (e) {
            console.error("DTC Error:", e);
        }
    };

    // --- Checkout Buton Yönetimi ---
    const toggleCheckout = (root, isSelected) => {
        // Sadece root çevresindeki veya genel checkout butonlarını bul
        const allCheckoutBtns = document.querySelectorAll(CONFIG.CHECKOUT_SELECTORS.join(","));

        allCheckoutBtns.forEach(btn => {
            // Eğer buton zaten bizim tarafımızdan disable edildiyse ve seçim varsa aç
            if (!isSelected) {
                btn.setAttribute("disabled", "disabled");
                btn.classList.add("dtc-checkout-disabled");
                btn.style.opacity = "0.5";
                btn.style.pointerEvents = "none";
            } else {
                btn.removeAttribute("disabled");
                btn.classList.remove("dtc-checkout-disabled");
                btn.style.opacity = "";
                btn.style.pointerEvents = "";
            }
        });

        // UI Mesajlarını güncelle
        const badge = qs(root, "[data-status-badge]");
        const hint = qs(root, "[data-hint]");
        const chosen = qs(root, "[data-chosen]");

        if (isSelected) {
            if (badge) { badge.textContent = "Seçildi"; badge.className = "dtc-delivery__status is-success"; }
            if (hint) hint.style.display = "none";
            if (chosen) {
                chosen.style.display = "block";
                chosen.innerHTML = `✅ <strong>${root.dataset.selectedDate}</strong> tarihinde, <strong>${root.dataset.selectedTime}</strong> saatleri arasında teslim edilecek.`;
            }
        } else {
            if (badge) { badge.textContent = "Seçim Gerekli"; badge.className = "dtc-delivery__status"; }
            if (hint) hint.style.display = "block";
            if (chosen) chosen.style.display = "none";
        }
    };

    // --- Takvim Oluşturma (Render) ---
    const renderCalendar = (root) => {
        // KORUMA: Eğer zaten render edildiyse tekrar etme (Döngü engelleyici)
        if (root.dataset.dtcRendered === "true") {
            // Sadece durum kontrolü yap, HTML basma
            const selectedDate = root.dataset.selectedDate;
            const selectedTime = root.dataset.selectedTime;
            toggleCheckout(root, !!(selectedDate && selectedTime));
            return;
        }

        const wrapper = qs(root, ".dtc-days");
        if (!wrapper) return;

        const cutoffHour = parseInt(root.dataset.cutoffHour || "16", 10);
        const maxDays = parseInt(root.dataset.maxDays || "4", 10);
        const initialDate = root.dataset.initialDate || "";
        const initialTime = root.dataset.initialTime || "";

        const now = new Date();
        const startOffset = now.getHours() >= cutoffHour ? 1 : 0;

        let html = "";
        let activeIso = initialDate;

        // Geçmiş tarih kontrolü
        if (activeIso) {
            const checkD = new Date(activeIso);
            const todayZero = new Date(); todayZero.setHours(0, 0, 0, 0);
            if (checkD < todayZero) activeIso = "";
        }

        // Günleri oluştur
        for (let i = 0; i < maxDays; i++) {
            const d = addDays(now, startOffset + i);
            const iso = isoDate(d);
            const isSelected = (iso === activeIso);

            html += `
        <button type="button" class="dtc-day-btn ${isSelected ? 'selected' : ''}" data-iso="${iso}">
          <div class="dtc-day-name">${trDow(d)}</div>
          <div class="dtc-day-num">${prettyDate(d)}</div>
        </button>
      `;
        }

        wrapper.innerHTML = html;

        // İşaretle ki tekrar render edilmesin
        root.dataset.dtcRendered = "true";

        // Zaman butonlarını bul
        const timeButtons = qsa(root, ".dtc-time-btn");


        // --- Slot Kontrolü (Bugün için saat kısıtlaması) ---
        const checkTimeSlots = (dateIso) => {
            const todayIso = isoDate(new Date());
            const isToday = (dateIso === todayIso);
            const currentHour = new Date().getHours();

            // Slot butonlarını sıfırla
            timeButtons.forEach(btn => {
                btn.removeAttribute("disabled");
                btn.classList.remove("disabled");
            });

            if (isToday) {
                // Eğer saat 13:00'ı geçtiyse, 12:00 - 17:00 slotunu kapat
                if (currentHour >= 13) {
                    const earlySlotBtn = qs(root, '.dtc-time-btn[data-time="12:00 - 17:00"]');
                    if (earlySlotBtn) {
                        earlySlotBtn.setAttribute("disabled", "disabled");
                        earlySlotBtn.classList.add("disabled");

                        // Eğer bu slot seçiliyse seçimi kaldır
                        if (root.dataset.selectedTime === "12:00 - 17:00") {
                            earlySlotBtn.classList.remove("selected");
                            root.dataset.selectedTime = "";
                            toggleCheckout(root, false);
                        }
                    }
                }
            }
        };

        // Başlangıç durumu
        if (activeIso) {
            root.dataset.selectedDate = activeIso;
            checkTimeSlots(activeIso);
        }

        if (initialTime) {
            // Eğer slot disable edildiyse seçme
            const targetBtn = qs(root, `.dtc-time-btn[data-time="${initialTime}"]`);
            if (targetBtn && !targetBtn.hasAttribute("disabled")) {
                root.dataset.selectedTime = initialTime;
                targetBtn.classList.add("selected");
            }
        }

        // Eğer her ikisi de varsa checkout'u aç
        if (root.dataset.selectedDate && root.dataset.selectedTime) {
            toggleCheckout(root, true);
        } else {
            toggleCheckout(root, false);
        }

        // Click Eventlerini ekle (Delegation yerine direct binding daha güvenli burada)
        const buttons = qsa(wrapper, ".dtc-day-btn");
        buttons.forEach(btn => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();

                // UI Güncelle
                buttons.forEach(b => b.classList.remove("selected"));
                btn.classList.add("selected");

                const date = btn.dataset.iso;
                root.dataset.selectedDate = date;

                checkTimeSlots(date);

                const currentTime = root.dataset.selectedTime;

                if (currentTime) {
                    saveAttributes(date, currentTime);
                    toggleCheckout(root, true);
                } else {
                    // Sadece tarih seçildi, saat bekleniyor
                    toggleCheckout(root, false);
                }
            });
        });

        // Zaman seçimi eventleri
        timeButtons.forEach(btn => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();

                // UI Güncelle
                timeButtons.forEach(b => b.classList.remove("selected"));
                btn.classList.add("selected");

                const time = btn.dataset.time;
                root.dataset.selectedTime = time;
                const currentDate = root.dataset.selectedDate;

                if (currentDate) {
                    saveAttributes(currentDate, time);
                    toggleCheckout(root, true);
                } else {
                    // Sadece saat seçildi, tarih bekleniyor
                    toggleCheckout(root, false);
                }
            });
        });
    };

    // --- Başlatıcı ve Frenleme Mekanizması ---
    const initAll = () => {
        const roots = document.querySelectorAll(CONFIG.ROOT);
        roots.forEach(renderCalendar);
    };

    // Debounce: Fonksiyonun çok sık çağrılmasını engeller
    let timeoutId;
    const safeInit = () => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(initAll, CONFIG.DEBOUNCE_MS);
    };

    // --- Gözlemci (MutationObserver) ---
    // Sadece body'deki büyük değişiklikleri izle ama safeInit ile frenle
    const observer = new MutationObserver((mutations) => {
        let shouldUpdate = false;
        for (const m of mutations) {
            // Eğer eklenen node bizim takvimimiz ise tekrar tetikleme
            if (m.target && m.target.closest && m.target.closest(CONFIG.ROOT)) {
                continue;
            }
            if (m.addedNodes.length > 0) {
                shouldUpdate = true;
                break;
            }
        }
        if (shouldUpdate) safeInit();
    });

    // Başlat
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => {
            safeInit();
            observer.observe(document.body, { childList: true, subtree: true });
        });
    } else {
        safeInit();
        observer.observe(document.body, { childList: true, subtree: true });
    }

    // Shopify Tema Eventleri (Opsiyonel destek)
    document.addEventListener("shopify:section:load", safeInit);
})();